import { render, staticRenderFns } from "./PodiumDisplay.vue?vue&type=template&id=192a8488&scoped=true"
import script from "./PodiumDisplay.vue?vue&type=script&lang=js"
export * from "./PodiumDisplay.vue?vue&type=script&lang=js"
import style0 from "./PodiumDisplay.vue?vue&type=style&index=0&id=192a8488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a8488",
  null
  
)

export default component.exports